// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__2nzwA","lpmain":"layout_lpmain__13FzF","flamingo":"layout_flamingo__9cC4c"};